module.exports = __webpack_public_path__ + "img/banner1.6a95d7da.jpg";